var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFalls = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 28.6H3V21.048H9.016V15.032H14.9959V9.016H21.0119V3H28.5995L28.6 28.6ZM4.536 27.0639H27.064V4.53591H22.5483V10.5519H16.5323V16.5679H10.552V22.5839H4.53595L4.536 27.0639Z",
    fill: "#327372"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFalls, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/falls.95a23edc.svg";
export { ForwardRef as ReactComponent };